import { isMobile, isIOS } from "react-device-detect";
export const isAbleToAddTheAppToHomeScreenInIOS = isMobile && isIOS;
